/* ===== LOTS BUILDER — VERSION CORRIGÉE ===== */

document.querySelectorAll('.lots-wrapper').forEach((builder) => {
  let selected = [];
  let target = 3;
  let isSubmitting = false;

  const prices = { 3: 15, 5: 26, 10: 49 };

  // ===== ÉLÉMENTS DOM =====
  const buttons      = builder.querySelectorAll('.lots-options button');
  const items        = builder.querySelectorAll('.lot-item');
  const selectedCount = builder.querySelector('.selected-count');
  const targetCount  = builder.querySelector('.target-count');
  const remainingCount = builder.querySelector('.remaining-count');
  const priceDisplay = builder.querySelector('.lot-price strong');
  const addBtn       = builder.querySelector('.add-bundle');
  const savingsDisplay = builder.querySelector('.lot-savings strong');
  const progressBar  = builder.querySelector('.lots-progress-bar');
  const progressText = builder.querySelector('.lots-progress-text');

  // ===== TOAST (remplace les alert natifs) =====
  function showToast(message) {
    let toast = builder.querySelector('.lots-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lots-toast';
      builder.querySelector('.lots-top').appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('visible'), 3000);
  }

  // ===== UTILITAIRES =====
  function getItemQty(id) {
    return selected.filter((x) => x === id).length;
  }

  // ===== PRIX — lecture depuis data-price (centimes Shopify) =====
  function getItemPrice(item) {
    const raw = item.dataset.price;
    if (raw) return parseInt(raw, 10) / 100;
    // fallback si data-price absent : lecture du DOM
    const priceEl = item.querySelector('.new-price');
    if (!priceEl) return 0;
    const cleaned = priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }

  // ===== SYNC VISUEL D'UNE CARTE =====
  function syncItemState(item, isSelected) {
    item.classList.toggle('selected', isSelected);
    const heartBtn = item.querySelector('.add-btn');
    if (!heartBtn) return;
    const icon  = heartBtn.querySelector('.icon');
    const label = heartBtn.querySelector('.label');
    if (!icon || !label) {
      heartBtn.textContent = isSelected ? '❤' : '♡';
    } else {
      icon.textContent  = isSelected ? '❤' : '♡';
      label.textContent = isSelected ? 'Ajouté' : 'Ajouter';
    }
    heartBtn.setAttribute(
      'aria-label',
      (isSelected ? 'Retirer ' : 'Ajouter ') +
      (item.dataset.title || 'ce produit') +
      (isSelected ? ' du lot' : ' au lot')
    );
  }

  function refreshItemDisplay(item) {
    const id  = item.dataset.id;
    const qty = getItemQty(id);
    const qtyDisplay = item.querySelector('.qty-value');
    if (qtyDisplay) qtyDisplay.textContent = qty;
    syncItemState(item, qty > 0);
  }

  function refreshAllItems() {
    items.forEach((item) => refreshItemDisplay(item));
  }

  // ===== MISE À JOUR DE L'UI GLOBALE =====
  function updateUI() {
    const count     = selected.length;
    const remaining = Math.max(target - count, 0);
    const progress  = Math.min((count / target) * 100, 100);

    // compteur
    if (selectedCount)  selectedCount.textContent  = count;
    if (targetCount)    targetCount.textContent    = target;
    if (remainingCount) remainingCount.textContent = remaining;

    // prix du lot
    if (priceDisplay) priceDisplay.textContent = prices[target] + '€';

    // calcul économies — via data-price (robuste)
    let normalTotal = 0;
    selected.forEach((id) => {
      const item = builder.querySelector(`.lot-item[data-id="${id}"]`);
      if (item) normalTotal += getItemPrice(item);
    });
    const savings = Math.max(normalTotal - prices[target], 0);
    if (savingsDisplay) {
      savingsDisplay.textContent = savings > 0
        ? savings.toFixed(2).replace('.', ',') + '€'
        : '0€';
    }

    // barre de progression
    if (progressBar) progressBar.style.width = progress + '%';

    // boutons taille de lot
    buttons.forEach((btn) => {
      const isActive = parseInt(btn.dataset.size, 10) === target;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // état global ready / not ready
    if (count === target) {
      builder.classList.add('ready');
      if (addBtn)      addBtn.textContent      = '✨ Je crée mon lot';
      if (progressText) progressText.textContent = 'Ton lot est prêt ✨';
    } else {
      builder.classList.remove('ready');
      if (addBtn) {
        addBtn.textContent = count === 0
          ? 'Je crée mon lot'
          : 'Encore ' + remaining + ' produit(s)';
      }
      if (progressText) {
        progressText.textContent = 'Choisis encore ' + remaining + ' produit(s)';
      }
    }
  }

  // ===== RESET =====
  function resetSelection() {
    selected = [];
    refreshAllItems();
    updateUI();
  }

  // ===== AJOUTER UN PRODUIT =====
  function addOne(id, item) {
    const stock      = parseInt(item.dataset.stock || '999', 10);
    const currentQty = getItemQty(id);

    if (currentQty >= stock) {
      showToast("Rupture de stock 💔 Écris-moi et je vérifie pour toi 💌");
      return;
    }

    if (selected.length >= target) {
      const messages = {
        3:  'Tu veux plus de produits ? Passe au lot de 5 💡',
        5:  'Tu veux plus de produits ? Passe au lot de 10 💡',
        10: 'Tu veux un lot plus grand ? Écris-moi, je te le prépare 💌'
      };
      showToast(messages[target] || messages[10]);
      return;
    }

    selected.push(id);
    refreshItemDisplay(item);
    updateUI();
  }

  // ===== RETIRER UN PRODUIT =====
  function removeOne(id, item) {
    const index = selected.indexOf(id);
    if (index === -1) return;
    selected.splice(index, 1);
    refreshItemDisplay(item);
    updateUI();
  }

  // ===== EVENTS : boutons taille de lot =====
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      target = parseInt(btn.dataset.size, 10);
      resetSelection();
    });
  });

  // ===== EVENTS : cartes produits =====
  items.forEach((item) => {
    const id       = item.dataset.id;
    const plusBtn  = item.querySelector('.qty-plus');
    const minusBtn = item.querySelector('.qty-minus');
    const heartBtn = item.querySelector('.add-btn');

    if (plusBtn) {
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // debounce léger
        plusBtn.disabled = true;
        addOne(id, item);
        setTimeout(() => { plusBtn.disabled = false; }, 150);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        minusBtn.disabled = true;
        removeOne(id, item);
        setTimeout(() => { minusBtn.disabled = false; }, 150);
      });
    }

    if (heartBtn) {
      heartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        addOne(id, item);
      });
    }

    refreshItemDisplay(item);
  });

  // ===== EVENT : bouton créer le lot =====
  if (addBtn) {
    addBtn.addEventListener('click', async () => {
      if (selected.length !== target) {
        showToast('Sélectionne exactement ' + target + ' produits pour créer ton lot 💖');
        return;
      }
      if (isSubmitting) return;

      isSubmitting = true;
      const originalText = addBtn.textContent;
      addBtn.textContent = 'Ajout en cours...';

      // regrouper les quantités
      const grouped = {};
      selected.forEach((id) => {
        grouped[id] = (grouped[id] || 0) + 1;
      });

      const itemsToAdd = Object.entries(grouped).map(([id, qty]) => ({
        id: Number(id),
        quantity: qty
      }));

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: itemsToAdd })
        });

        if (!response.ok) {
          throw new Error("Erreur lors de l'ajout au panier");
        }

        isSubmitting = false;
        window.location.href = '/cart';

      } catch (error) {
        console.error(error);
        showToast("Oups, une erreur est survenue lors de l'ajout du lot au panier.");
        addBtn.textContent = originalText;
        isSubmitting = false;
      }
    });
  }

  // ===== INIT =====
  updateUI();
});